export enum MenuItemType {
  Delete = 'delete',
  Edit = 'edit',
}
